import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Outlet, useNavigate } from 'react-router-dom'
import styles from './BuilderContainer.module.css'

export const BuilderContainer = () => {
    const { token } = useSelector(state => state.auth)
    const navigate = useNavigate()

    useEffect(() => {
        if (!token) {
            navigate('/player')
        }
    }, [])

    return <div
        className={styles.builderContainer}
    >
        <Outlet />
    </div>
}